const AuctionIcon = ({ color = "#2c2c2c", width = 24, height = 24 }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 800"
    width={width}
    height={height}
  >
    <path
      d="M288.34,129.68l170.79,98.61c13.5,7.78,30.71,3.16,38.46-10.31,7.8-13.47,3.18-30.71-10.28-38.46l-170.79-98.61c-13.5-7.78-30.71-3.16-38.49,10.28-7.78,13.44-3.16,30.68,10.31,38.49h0ZM445.08,252.69l-170.79-98.61-98.61,170.79,170.79,98.61,98.61-170.79ZM133.38,398.07l170.79,98.61c13.47,7.78,30.71,3.16,38.46-10.31,7.75-13.47,3.16-30.71-10.28-38.46l-170.79-98.61c-13.5-7.78-30.71-3.16-38.49,10.28-7.8,13.47-3.16,30.71,10.31,38.49h0ZM721.92,477.58l-312.06-163.89-28.17,48.8,297.98,188.29c20.2,11.66,46.07,4.76,57.73-15.47,11.66-20.23,4.73-46.07-15.47-57.73h0ZM412.59,619.83c0-15.58-12.62-28.17-28.17-28.17h-253.57c-15.58,0-28.17,12.59-28.17,28.17v28.17l-29.1-.59.93,28.77h366.27l1.32-26.99-27.72-1.18s-1.77-12.62-1.77-28.17h0Z"
      style={{ fill: color, strokeWidth: "0px" }}
    />
  </svg>
);
export default AuctionIcon;
